export default class GeneralInformationController {
    $onInit() {
        if (!this.isEditing) {
            this.isEditing = false;
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/general-information/general-information.controller.js